import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { RolesList } from '@gtpl/shared-models/gtpl';
import { EmployeeRolesEnum, EmpPrefixEnum } from '@gtpl/shared-models/common-models';
import { EmployeeFamilyDetailsDTO } from './employee-family-details.dto';
import { EmployeeEducationDetailsDTO } from './employee-education-details.dto';
import { EmployeeExperienceDetailsDTO } from './employee-experience-details.dto';
import { EmployeeIdProofDetailsDTO } from './employee-id-proof-details.dto';
export class EmployeeDetailsDTO {

  @ApiProperty()
  @IsNotEmpty()
  employeeType: string;

  @ApiProperty()
  @IsOptional()
  employeeId: number;

  @ApiProperty()
  @MaxLength(12, { message: "Employee Code allows maximum 12 characters" })
  @IsNotEmpty({ message: "Employee Code should not be empty" })
  @IsAlphanumeric()
  employeeCode: string;

  @ApiProperty()
  @MaxLength(30, { message: "Employee Name allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Employee name should be only alpha numeric" })
  employeeName: string;

  @ApiProperty()
  @MaxLength(30, { message: "Employee Last Name allows maximum 30 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Employee Last name should be only alpha numeric" })
  employeeLastName: string;

  @ApiProperty()
  @IsNotEmpty()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  @Matches(new RegExp("^[0-9\\s]+$"), { message: "Employee mobile no should be only numeric. " })
  mobileNumber: string;

  @ApiProperty()
  teamCode: string;

  @ApiProperty({ enum: ["ADMIN", "OPERATIONS_MANAGER", "OPERATIONS_EXECUTIVE", "DOCUMENTATION_MANAGER", "DOCUMENTATION_EXECUTIVE", "TRANSPORTATION_MANAGER", "TRANSPORTATION_EXECUTIVE"] })
  employeeRole: EmployeeRolesEnum;

  @ApiProperty()
  @IsOptional()
  unitId: number;

  @ApiProperty()
  prefix: EmpPrefixEnum;

  @ApiProperty()
  dateOfBirth: Date;

  @ApiProperty()
  gender: string;

  @ApiProperty()
  maritualStatus: string;

  @ApiProperty()
  altMobileNumber: string;

  @ApiProperty()
  emailID: string;

  @ApiProperty()
  bloodGroup: string;

  @ApiProperty()
  nationality: string;

  @ApiProperty()
  departmentId: string;

  // @ApiProperty()
  // deptId: number;

  @ApiProperty()
  priorityOne: string;

  @ApiProperty()
  priorityType: string;

  @ApiProperty()
  currentAddress: string;

  @ApiProperty()
  permanentAddress: string;

  @ApiProperty()
  state: string;

  @ApiProperty()
  pinCode: string;

  @ApiProperty()
  permanentState: string;

  @ApiProperty()
  permanentPinCode: string;

  @ApiProperty()
  qualification: string;

  @ApiProperty()
  yearsOfExperience: Number;

  @ApiProperty()
  companyEmail: string;

  @ApiProperty()
  employeeMode: string;

  @ApiProperty()
  employeeStatus: string;

  @ApiProperty()
  contractorName: string;

  @ApiProperty()
  shiftGroup: string;

  @ApiProperty()
  dateOfJoin: Date;

  @ApiProperty()
  dateOfleave: Date;

  @ApiProperty()
  workstationNumber: string;

  @ApiProperty()
  healthCardNumber: string;

  @ApiProperty()
  uanNumber: string;

  @ApiProperty()
  status: string;

  @ApiProperty()
  salary: string;

  @ApiProperty()
  bankAccountNumber: string;

  @ApiProperty()
  ifscCode: string;

  @ApiProperty()
  designation: string;

  @ApiProperty()
  aadhaarNumber: string;

  @ApiProperty()
  dateOfEntry: Date;

  @ApiProperty()
  emergencyContactNo: string;

  @ApiProperty()
  emergencyContactName: string;

  @ApiProperty()
  isProbPeriodCompleted: string;

  @ApiProperty()
  transportation: string;

  @ApiProperty()
  accommodation: string;

  @ApiProperty()
  isAuditCompleted: string;

  @ApiProperty()
  skillSet: string;

  @ApiProperty()
  pickUpPoint: string;

  @ApiProperty()
  routeNumber: string;

  @ApiProperty()
  employeeCategory: string;

  @ApiProperty()
  wageType: string;

  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  createdAt: Date;

  @ApiProperty()
  @IsOptional()
  createdUser: string;


  @ApiProperty()
  updatedAt: Date;

  @ApiProperty()
  @IsOptional()
  updatedUser: string;

  @ApiProperty()
  versionFlag: number;

  @ApiProperty()
  Fname: string;

  @ApiProperty()
  aadhaarCard: number;

  @ApiProperty()
  mobilePhone: number;

  @ApiProperty()
  address: string;

  @ApiProperty()
  @IsOptional()
  familyDetails: EmployeeFamilyDetailsDTO[];

  @ApiProperty()
  @IsOptional()
  idProofDetails: EmployeeIdProofDetailsDTO[];

  @ApiProperty()
  @IsOptional()
  educationDetails: EmployeeEducationDetailsDTO[];

  @ApiProperty()
  @IsOptional()
  experienceDetails: EmployeeExperienceDetailsDTO[];

  @ApiProperty()
  image: string;

  @ApiProperty()
  panNumber: string;

  @ApiProperty()
  esiNumber: string;

  @ApiProperty()
  reportingManager: string;

  @ApiProperty()
  bankName: string;

  @ApiProperty()
  ghiNo: string;

  @ApiProperty()
  gpaNo: string;

}

